const React = require('react');
const { View } = require('react-native');

const RTCPeerConnection = typeof window !== 'undefined' && window.RTCPeerConnection ? window.RTCPeerConnection : class {};
const RTCSessionDescription = typeof window !== 'undefined' && window.RTCSessionDescription ? window.RTCSessionDescription : class {};
const RTCIceCandidate = typeof window !== 'undefined' && window.RTCIceCandidate ? window.RTCIceCandidate : class {};
const MediaStream = typeof window !== 'undefined' && window.MediaStream ? window.MediaStream : class {};
const MediaStreamTrack = typeof window !== 'undefined' && window.MediaStreamTrack ? window.MediaStreamTrack : class {};
const mediaDevices = typeof navigator !== 'undefined' && navigator.mediaDevices ? navigator.mediaDevices : {
  getUserMedia: async () => ({}),
  enumerateDevices: async () => [],
};
const RTCView = (props) => React.createElement(View, props);

module.exports = {
  RTCPeerConnection,
  RTCSessionDescription,
  RTCIceCandidate,
  MediaStream,
  MediaStreamTrack,
  mediaDevices,
  RTCView,
  registerGlobals: () => {},
};
